import jsPDF from "jspdf";
import "jspdf-autotable";

export const exportTrialBalPDF = ({ trialBalData, fromDate, toDate, societyName }) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "A4",
  });

  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatCurrency = (amount) => {
    const numberFormat = new Intl.NumberFormat("en-IN", {
      style: "decimal",
      minimumFractionDigits: 2,
    });
    return numberFormat.format(amount || 0);
  };

  const reportTitle = `Trial Balance : ${formatDate(fromDate)} to ${formatDate(toDate)}`;
  const reportDateTime = new Date().toLocaleString("en-IN", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const leftMargin = 14;
  const rightMargin = 14;
  const headerHeight = 30;

  /** ---------- HEADER ---------- **/
  const drawHeader = () => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text(societyName, doc.internal.pageSize.getWidth() / 2, 15, { align: "center" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(reportTitle, doc.internal.pageSize.getWidth() / 2, 23, { align: "center" });
  };

  /** ---------- BUILD TABLE CONTENT ---------- **/
  const tableRows = trialBalData.map((tb) => {
    const isTotal = tb.particular === "GRAND TOTAL";
    const rowStyle = isTotal
      ? { fontStyle: "bold", fillColor: [240, 240, 240] }
      : {};

    return [
      { content: tb.particular || "", styles: rowStyle },
      { content: formatCurrency(tb.open_bal_dr), styles: rowStyle },
      { content: formatCurrency(tb.open_bal_cr), styles: rowStyle },
      { content: formatCurrency(tb.tran_dr), styles: rowStyle },
      { content: formatCurrency(tb.tran_cr), styles: rowStyle },
      { content: formatCurrency(tb.closing_dr), styles: rowStyle },
      { content: formatCurrency(tb.closing_cr), styles: rowStyle },
    ];
  });

  if (!trialBalData.length) {
    tableRows.push([
      { content: "No Record found.", colSpan: 7, styles: { halign: "center", fontStyle: "italic" } },
    ]);
  }

  /** ---------- DRAW TABLE ---------- **/
  doc.autoTable({
    startY: headerHeight,
    margin: { left: leftMargin, right: rightMargin },
    theme: "grid",
    styles: { fontSize: 9, cellPadding: 2, lineColor: [0, 0, 0] },
    headStyles: { 
//      fillColor: [41, 128, 185], 
      fillColor: [140, 179, 218],
      //textColor: 255, 
      textColor: [0, 0, 0], 
      lineColor: [0, 0, 0], lineWidth: 0.1, halign: "center" },
    columnStyles: {
      0: { halign: "left", cellWidth: 90 },
      1: { halign: "right", cellWidth: 31 },
      2: { halign: "right", cellWidth: 31 },
      3: { halign: "right", cellWidth: 31 },
      4: { halign: "right", cellWidth: 31 },
      5: { halign: "right", cellWidth: 31 },
      6: { halign: "right", cellWidth: 31 },
    },
    // 👇 Two-tier header structure like the HTML table
    head: [
      [
        { content: "Particular", rowSpan: 2, styles: { halign: "left", valign: "middle" } },
        { content: "Opening Balance", colSpan: 2, styles: { halign: "center" } },
        { content: "Transactions", colSpan: 2, styles: { halign: "center" } },
        { content: "Closing Balance", colSpan: 2, styles: { halign: "center" } },
      ],
      [
        { content: "Amount (Dr)", styles: { halign: "right" } },
        { content: "Amount (Cr)", styles: { halign: "right" } },
        { content: "Amount (Dr)", styles: { halign: "right" } },
        { content: "Amount (Cr)", styles: { halign: "right" } },
        { content: "Amount (Dr)", styles: { halign: "right" } },
        { content: "Amount (Cr)", styles: { halign: "right" } },
      ],
    ],
    body: tableRows,

    didDrawPage: (data) => {
      // Header
      drawHeader();

      // Footer
      const pageWidth = doc.internal.pageSize.getWidth();
      const footerY = doc.internal.pageSize.getHeight() - 10;

      doc.setFontSize(9);
      doc.setDrawColor(150);
      doc.line(leftMargin, footerY - 3, pageWidth - rightMargin, footerY - 3);
      doc.text(`eSchool`, leftMargin, footerY + 2);
      doc.text(
        `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
        pageWidth / 2,
        footerY + 2,
        { align: "center" }
      );
      doc.text(`Generated on: ${reportDateTime}`, pageWidth - rightMargin, footerY + 2, {
        align: "right",
      });
    },
  });

  /** ---------- SAVE ---------- **/
  doc.save(`Trial_Balance_${formatDate(fromDate)}_to_${formatDate(toDate)}.pdf`);
};
